var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"ct",staticStyle:{"height":"100%","width":"100%"}},[_c('div',{ref:"charts",staticStyle:{"height":"100%","width":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }